const ENVIRONMENTS = Object.freeze({
    local: 'local',
    dev: 'development',
    stg: 'staging',
    prod: 'production',
});

export default ENVIRONMENTS;
